/* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */

export enum ContactMethods {
    Sms = 'Sms',
    Email = 'Email'
}
